import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { Model } from 'services/models/model';

export class FormItemOptionModel extends Model implements IModel<FormItemOptionModel> {
  public label: string = '';
  public legend: string = '';
  public order: number = 0;
  public formItemId: string = '';
  public description: string = '';
  public isUpdate: boolean = false;
  public iconName: string = '';

  static create(input: any): FormItemOptionModel {
    return ObjectMapper.deserialize<FormItemOptionModel>(FormItemOptionModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
